import React from "react";
import { categoriesData } from "../../constant/categoriesData";
import ProductCard from "../../Common/ProductCard";
import SectionHeader from "./SectionHeader";

// The three categories added most recently to the catalogue. Surfacing them
// gives the newest stock a route in from the homepage instead of leaving it
// three clicks deep.
const NEW_CATEGORIES = [
  "End-User Computing",
  "Components & Spares",
  "Security Appliances",
];

const NEW_ARRIVALS = NEW_CATEGORIES.flatMap((name) => {
  const cat = categoriesData.find((c) => c.category === name);
  if (!cat) return [];
  return (cat.subcategories || [])
    .filter((item) => item.bestSeller)
    .slice(0, 2)
    .map((item) => ({ ...item, category: cat.category }));
});

const NewArrivals = () => {
  if (!NEW_ARRIVALS.length) return null;

  return (
    <section className="bg-white py-8">
      <div className="mx-auto max-w-[88rem] px-4 sm:px-6">
        <SectionHeader
          title="New to the catalogue"
          subtitle="Client hardware, server spares and security appliances"
          to="/category/components-spares"
          linkLabel="Browse spares"
        />

        <div className="grid grid-cols-2 gap-3 sm:gap-4 md:grid-cols-3 lg:grid-cols-6">
          {NEW_ARRIVALS.map((item) => (
            <ProductCard
              key={`${item.category}-${item.name}`}
              item={item}
              category={item.category}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewArrivals;
